<template>
  <div class="product-slider">
    <slot />

    <UiCarousel
      :class="{
        /* Non responsive & non modern settings */
        'ui-carousel--navigation': true,
      }"
      next-label="Next"
      prev-label="Prev"
    >
      <template
        v-if="$slots.slide"
        #slide
      >
        <slot name="slide" />
      </template>

      <template
        v-for="(product, index) in products"
        #[`slide-${index}`]
        :key="index"
      >
        <ProductTile
          v-if="product && product?.name"
          :product="product"
          :lazy="lazy || index > 2"
          class="product-slider__product"
          :show-cta="showCta"
          :force-packshot="forcePackshot"
        />
      </template>
    </UiCarousel>
  </div>
</template>

<script setup lang="ts">
import type { EsProduct } from '~/types/elastic'

withDefaults(defineProps<{
  products: EsProduct[]
  lazy?: boolean
  showCta?: boolean
  disableCls?: boolean
  customSettings?: any
  forcePackshot?: boolean
}>(), {
  lazy: true,
  showCta: false,
  disableCls: false,
  customSettings: null,
  forcePackshot: false,
})
</script>

<style>
@import url("~layers/app/components/Product/Slider.css");

.product-slider {
  .ui-carousel {
    --gap: 0.8rem;
    --padding: 1.6rem;
    --visible-slides: 1.3;
    --navigation: false;

    @media (--phablet-plus) {
      --gap: 2.4rem;
      --padding: 1.6rem;
      --visible-slides: 2.4;
    }

    @media (--tablet-plus) {
      --gap: 2.4rem;
      --padding: 3.4rem;
      --visible-slides: 3;
      --navigation: true;
    }

    @media (--desktop-plus) {
      --gap: 2.4rem;
      --padding: 0;
      --visible-slides: 4;
    }
  }

}
</style>
